/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingPropertyDetails_listing$ref: FragmentReference;
declare export opaque type AggregatesListingPropertyDetails_listing$fragmentType: AggregatesListingPropertyDetails_listing$ref;
export type AggregatesListingPropertyDetails_listing = {|
  +livingSurface: ?number,
  +usableSurface: ?number,
  +gardenSurface: ?number,
  +terraceSurface: ?number,
  +balconySurface: ?number,
  +landSurface: ?number,
  +numberOfRooms: ?number,
  +numberOfBedrooms: ?number,
  +numberOfBathrooms: ?number,
  +availableFrom: ?string,
  +constructionYear: ?number,
  +renovationYear: ?number,
  +floorOfFlat: ?number,
  +numberOfLevels: ?number,
  +volume: ?number,
  +numberOfIndoorParkings: ?number,
  +numberOfOutdoorParkings: ?number,
  +numberOfToilets: ?number,
  +url: ?{|
    +originalDomain: string
  |},
  +$refType: AggregatesListingPropertyDetails_listing$ref,
|};
export type AggregatesListingPropertyDetails_listing$data = AggregatesListingPropertyDetails_listing;
export type AggregatesListingPropertyDetails_listing$key = {
  +$data?: AggregatesListingPropertyDetails_listing$data,
  +$fragmentRefs: AggregatesListingPropertyDetails_listing$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingPropertyDetails_listing",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "livingSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "usableSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gardenSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "terraceSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "balconySurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "landSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfRooms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfBedrooms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfBathrooms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availableFrom",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "constructionYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "renovationYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "floorOfFlat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfLevels",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "volume",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfIndoorParkings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfOutdoorParkings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfToilets",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ExternalUrl",
      "kind": "LinkedField",
      "name": "url",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalDomain",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AggregatesListing",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '9821c850886d78e34894b1e4f92d68b5';

export default node;
